import LinearProgress from '@mui/material/LinearProgress';
import DataExportsWrapper from '../components/dataExports/DataExportsWrapper';
import useSetOrg from '../components/hooks/useSetOrg';
import useUserInfo from '../components/hooks/useUserInfo';
import { useNavigate, useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

interface ParamTypes {
  [key: string]: string | undefined;
  dpid?: string;
}

const DataExportsPage = () => {
  useSetTitle(`Data Exports`);
  const navigate = useNavigate();
  const userInfo = useUserInfo();

  const { dpid } = useParams<ParamTypes>();
  const { loading, error } = useSetOrg(dpid);

  if (userInfo.isLoading) {
    return <LinearProgress />;
  }

  if (!userInfo.data?.is_staff) {
    navigate('/');
    return null;
  }

  return <DataExportsWrapper />;
};

export default DataExportsPage;
